export const scrollToHash = (hash: string, isMobile: boolean) => {
	setTimeout(() => {
		const section = document.querySelector(`#_${hash}`);
		if (!section) return;

		let top = section.getBoundingClientRect().top + document.documentElement.scrollTop;
		if (isMobile) {
			const mobileHeaderHeight = 70;
			top -= mobileHeaderHeight;
		}
		window.scrollTo({
			top,
			behavior: 'smooth',
		});
	}, 100);
};
